export const ROLE_TYPES ={
    ADMIN: "admin",
    MANAGER: "manager",
    USER:"user",
};